import { Box } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import PhoneInput from 'react-phone-input-2'

import { FormContext, type FormInputType } from '../types'

const FormInputPhone: React.FC<{
  input: FormInputType & { type: 'phone' }
}> = ({ input }) => {
  const { name: inputName } = input
  const { onChange } = React.useContext(FormContext)
  const [value, setValue] = React.useState(input.initialValue ?? null)

  const handleChange = React.useCallback(
    (newValue: string) => {
      onChange(inputName, newValue)
      setValue(newValue)
    },
    [inputName, onChange]
  )

  const preferredCountries = useMemo(() => ['us'], [])

  return (
    <Box maxWidth="200px">
      <PhoneInput
        value={value}
        country="us"
        placeholder={input.placeholder ?? ''}
        onChange={handleChange}
        preferredCountries={preferredCountries}
        containerStyle={{ width: '100%' }}
        inputStyle={{ width: '100%' }}
      />
    </Box>
  )
}

export default FormInputPhone
